import { render, staticRenderFns } from "./FontDisplay.vue?vue&type=template&id=5cbab1e8&scoped=true"
import script from "./FontDisplay.vue?vue&type=script&lang=js"
export * from "./FontDisplay.vue?vue&type=script&lang=js"
import style0 from "./FontDisplay.vue?vue&type=style&index=0&id=5cbab1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbab1e8",
  null
  
)

export default component.exports